'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _reactIntl = require('react-intl');

var _forms = require('utils/forms');

var _components2 = require('components');

var _forms2 = require('metadata/forms');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var galapagosAckno = function galapagosAckno(tourName) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'formAcknowledgements.galapagosAckno',
        defaultMessage: '{stubText}',
        values: {
            stubText: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formAcknowledgements.galapagosAcknoTitle',
                        defaultMessage: 'Galapagos Boat Change' }),
                    _react2.default.createElement(
                        'span',
                        { className: 'tourName' },
                        tourName
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formAcknowledgements.galapagosAcknoText',
                        defaultMessage: 'Please acknowledge the change affecting\n                                             your upcoming Galapagos voyage.' })
                )
            )
        } });
};

var hotelChangeAckno = function hotelChangeAckno(tourName) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'formAcknowledgements.hotelChangeAckno',
        defaultMessage: '{stubText}',
        values: {
            stubText: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formAcknowledgements.hotelChangeAcknoTitle',
                        defaultMessage: 'Hotel Change' }),
                    _react2.default.createElement(
                        'span',
                        { className: 'tourName' },
                        tourName
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formAcknowledgements.hotelChangeAcknoText',
                        defaultMessage: 'We just need to make sure that you\'re aware of\n                                             the slight change to your itinerary - you should\n                                             have received an email communication from us recently.' })
                )
            )
        } });
};

var itineraryChangeAckno = function itineraryChangeAckno(tourName) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'formAcknowledgements.itineraryChangeAckno',
        defaultMessage: '{stubText}',
        values: {
            stubText: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formAcknowledgements.itineraryChangeAcknoTitle',
                        defaultMessage: 'Itinerary Change' }),
                    _react2.default.createElement(
                        'span',
                        { className: 'tourName' },
                        tourName
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formAcknowledgements.itineraryChangeAcknoText',
                        defaultMessage: 'Please acknowledge the interary change affecting\n                                             your upcoming G Adventure.' })
                )
            )
        } });
};

var oddNumTravellersAckno = function oddNumTravellersAckno(tourName) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'formAcknowledgements.oddNumTravellersAckno',
        defaultMessage: '{stubText}',
        values: {
            stubText: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formAcknowledgements.oddNumTravellersAcknoTitle',
                        defaultMessage: 'Odd Number of Travellers' }),
                    _react2.default.createElement(
                        'span',
                        { className: 'tourName' },
                        tourName
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formAcknowledgements.oddNumTravellersAcknoText',
                        defaultMessage: 'As there is an odd number of travellers in your\n                                             party, you may wish to reach us by phone or email to\n                                             inform us as to which traveller will be sharing a room\n                                             with another G Traveller outside your party.' })
                )
            )
        } });
};

var serviceGapAckno = function serviceGapAckno(tourName) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'formAcknowledgements.serviceGapAckno',
        defaultMessage: '{stubText}',
        values: {
            stubText: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formAcknowledgements.serviceGapAcknoTitle',
                        defaultMessage: 'Service Gap' }),
                    _react2.default.createElement(
                        'span',
                        { className: 'tourName' },
                        tourName
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formAcknowledgements.serviceGapAcknoText',
                        defaultMessage: 'We just want to make sure you\'re aware that you\'ve\n                                             booked some additional nights outside of the scheduled\n                                             itinerary. If you would like a quote for additional\n                                             accommodation, please contact us by phone or email.' })
                )
            )
        } });
};

var unusualStartEndTimeAckno = function unusualStartEndTimeAckno(tourName) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'formAcknowledgements.unusualStartEndTimeAckno',
        defaultMessage: '{stubText}',
        values: {
            stubText: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formAcknowledgements.unusualStartEndTimeAcknoTitle',
                        defaultMessage: 'Unusual Start/End Time' }),
                    _react2.default.createElement(
                        'span',
                        { className: 'tourName' },
                        tourName
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formAcknowledgements.unusualStartEndTimeAcknoText',
                        defaultMessage: 'We just want to make sure you\'re aware that your\n                                             adventure starts/ends at a specified time.' })
                )
            )
        } });
};

var travellingWithMinors = function travellingWithMinors(tourName) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'formAcknowledgements.travellingWithMinors',
        defaultMessage: '{stubText}',
        values: {
            stubText: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h4',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formAcknowledgements.travellingWithMinorsTitle',
                        defaultMessage: 'Travelling With Minors' }),
                    _react2.default.createElement(
                        'span',
                        { className: 'tourName' },
                        tourName
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formAcknowledgements.travellingWithMinorsTitleText',
                        defaultMessage: 'We just want to make sure that you\u2019re aware\n                            that depending on the country, minors traveling without both\n                            parents may require notarized permission and/or other supporting\n                            travel documents.' })
                )
            )
        } });
};

var Acknowledgements = function Acknowledgements(_ref) {
    var intl = _ref.intl,
        initialValues = _ref.initialValues,
        departureServicesById = _ref.departureServicesById,
        requirementsByCode = _ref.requirementsByCode,
        bookingId = _ref.bookingId,
        isFetchingRequirementData = _ref.isFetchingRequirementData,
        handleSubmit = _ref.handleSubmit,
        error = _ref.error,
        invalid = _ref.invalid,
        pristine = _ref.pristine,
        submitSucceeded = _ref.submitSucceeded,
        submitFailed = _ref.submitFailed,
        submitting = _ref.submitting;


    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components2.FormErrorMessage, { errorCode: error, invalid: invalid, submitFailed: submitFailed, submitting: submitting }),
        _react2.default.createElement(
            'form',
            null,
            requirementsByCode.GALAPAGOS_BOAT_CHANGE && requirementsByCode.GALAPAGOS_BOAT_CHANGE.map(function (req, i) {
                return _react2.default.createElement(
                    'div',
                    { key: i },
                    _react2.default.createElement(_components2.FormStubText, { stubText: galapagosAckno((0, _forms.getTourName)(departureServicesById, req)) }),
                    _react2.default.createElement(_components2.FieldSet, {
                        requirement: req,
                        fields: [(0, _extends3.default)({}, (0, _forms.generateOverride)({
                            intl: intl,
                            id: 'galapagosAckno',
                            requirement: req,
                            overrideLabels: _forms2.formOverrides.acknowledgements,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] })
                );
            }),
            requirementsByCode.HOTEL_CHANGE_ACKNOWLEDGEMENT && requirementsByCode.HOTEL_CHANGE_ACKNOWLEDGEMENT.map(function (req, i) {
                return _react2.default.createElement(
                    'div',
                    { key: i },
                    _react2.default.createElement(_components2.FormStubText, { stubText: hotelChangeAckno((0, _forms.getTourName)(departureServicesById, req)) }),
                    _react2.default.createElement(_components2.FieldSet, {
                        requirement: req,
                        fields: [(0, _extends3.default)({}, (0, _forms.generateOverride)({
                            intl: intl,
                            id: 'hotelChangeAckno',
                            requirement: req,
                            overrideLabels: _forms2.formOverrides.acknowledgements,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] })
                );
            }),
            requirementsByCode.ITINERARY_CHANGE && requirementsByCode.ITINERARY_CHANGE.map(function (req, i) {
                return _react2.default.createElement(
                    'div',
                    { key: i },
                    _react2.default.createElement(_components2.FormStubText, { stubText: itineraryChangeAckno((0, _forms.getTourName)(departureServicesById, req)) }),
                    _react2.default.createElement(_components2.FieldSet, {
                        requirement: req,
                        fields: [(0, _extends3.default)({}, (0, _forms.generateOverride)({
                            intl: intl,
                            id: 'itineraryChangeAckno',
                            requirement: req,
                            overrideLabels: _forms2.formOverrides.acknowledgements,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] })
                );
            }),
            requirementsByCode.ODD_NUMBER_OF_TRAVELLERS && requirementsByCode.ODD_NUMBER_OF_TRAVELLERS.map(function (req, i) {
                return _react2.default.createElement(
                    'div',
                    { key: i },
                    _react2.default.createElement(_components2.FormStubText, { stubText: oddNumTravellersAckno((0, _forms.getTourName)(departureServicesById, req)) }),
                    _react2.default.createElement(_components2.FieldSet, {
                        requirement: req,
                        fields: [(0, _extends3.default)({}, (0, _forms.generateOverride)({
                            intl: intl,
                            id: 'oddNumTravellersAckno',
                            requirement: req,
                            overrideLabels: _forms2.formOverrides.acknowledgements,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] })
                );
            }),
            requirementsByCode.SERVICE_GAP_ACKNOWLEDGEMENT && requirementsByCode.SERVICE_GAP_ACKNOWLEDGEMENT.map(function (req, i) {
                return _react2.default.createElement(
                    'div',
                    { key: i },
                    _react2.default.createElement(_components2.FormStubText, { stubText: serviceGapAckno((0, _forms.getTourName)(departureServicesById, req)) }),
                    _react2.default.createElement(_components2.FieldSet, {
                        requirement: req,
                        fields: [(0, _extends3.default)({}, (0, _forms.generateOverride)({
                            intl: intl,
                            id: 'serviceGapAckno',
                            requirement: req,
                            overrideLabels: _forms2.formOverrides.acknowledgements,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] })
                );
            }),
            requirementsByCode.UNUSUAL_START_END_TIME && requirementsByCode.UNUSUAL_START_END_TIME.map(function (req, i) {
                return _react2.default.createElement(
                    'div',
                    { key: i },
                    _react2.default.createElement(_components2.FormStubText, { stubText: unusualStartEndTimeAckno((0, _forms.getTourName)(departureServicesById, req)) }),
                    _react2.default.createElement(_components2.FieldSet, {
                        requirement: req,
                        fields: [(0, _extends3.default)({}, (0, _forms.generateOverride)({
                            intl: intl,
                            id: 'unusualStartEndTimeAckno',
                            requirement: req,
                            overrideLabels: _forms2.formOverrides.acknowledgements,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] })
                );
            }),
            requirementsByCode.TRAVELLING_WITH_MINORS && requirementsByCode.TRAVELLING_WITH_MINORS.map(function (req, i) {
                return _react2.default.createElement(
                    'div',
                    { key: i },
                    _react2.default.createElement(_components2.FormStubText, { stubText: travellingWithMinors((0, _forms.getTourName)(departureServicesById, req)) }),
                    _react2.default.createElement(_components2.FieldSet, {
                        requirement: req,
                        fields: [(0, _extends3.default)({}, (0, _forms.generateOverride)({
                            intl: intl,
                            id: 'travellingWithMinors',
                            requirement: req,
                            overrideLabels: _forms2.formOverrides.acknowledgements,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] })
                );
            }),
            _react2.default.createElement(_components2.FormSubmit, {
                handleSubmit: handleSubmit,
                invalid: invalid,
                pristine: pristine,
                submitting: submitting,
                submitSucceeded: submitSucceeded,
                isFetchingRequirementData: isFetchingRequirementData })
        )
    );
};
Acknowledgements.propTypes = {
    intl: _propTypes2.default.object.isRequired,
    initialValues: _propTypes2.default.object.isRequired,
    departureServicesById: _propTypes2.default.object.isRequired,
    requirementsByCode: _propTypes2.default.object.isRequired,
    bookingId: _propTypes2.default.string.isRequired,
    isFetchingRequirementData: _propTypes2.default.bool.isRequired,
    handleSubmit: _propTypes2.default.func.isRequired,
    error: _propTypes2.default.string,
    invalid: _propTypes2.default.bool,
    pristine: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    submitSucceeded: _propTypes2.default.bool,
    submitFailed: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reduxForm.reduxForm)({
    form: 'Acknowledgements',
    enableReinitialize: true
})(Acknowledgements));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/forms/Acknowledgements.js
// module id = 1318
// module chunks = 0